import seo from './routes.json';

export const ORGANIZATION_ID = `${seo.siteUrl}/#organization`;
export const LINKEDIN_COMPANY = 'https://www.linkedin.com/company/kult-io/';
export const LINKEDIN_PRINCIPAL = 'https://www.linkedin.com/in/rafaljanicki/';

export const organizationLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': ORGANIZATION_ID,
  name: 'Kult.io',
  url: `${seo.siteUrl}/`,
  email: 'info@kult.io',
  description:
    'An AI engineering and AWS consultancy. We design and build AI agents that use your tools and documents to finish multi-step work, install AFK Development inside engineering teams, and have run production AWS for over ten years.',
  logo: {
    '@type': 'ImageObject',
    url: `${seo.siteUrl}/logo512.png`,
    width: 512,
    height: 512,
  },
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Aleja Powstania Warszawskiego 15',
    postalCode: '31-539',
    addressLocality: 'Kraków',
    addressCountry: 'PL',
  },
  sameAs: [LINKEDIN_COMPANY, LINKEDIN_PRINCIPAL],
};

export const websiteLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  url: `${seo.siteUrl}/`,
  name: 'Kult.io',
  publisher: { '@id': ORGANIZATION_ID },
};

export interface Crumb {
  name: string;
  path?: string;
}

// The final crumb is the current page, so schema.org wants it without an `item`.
export const breadcrumbLd = (crumbs: Crumb[]) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: crumbs.map((crumb, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: crumb.name,
    ...(crumb.path ? { item: `${seo.siteUrl}${crumb.path}` } : {}),
  })),
});

export const faqLd = (pairs: { question: string; answer: string }[]) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: pairs.map((pair) => ({
    '@type': 'Question',
    name: pair.question,
    acceptedAnswer: { '@type': 'Answer', text: pair.answer },
  })),
});

export const personLd = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: 'Rafał Janicki',
  url: LINKEDIN_PRINCIPAL,
  worksFor: { '@id': ORGANIZATION_ID },
  hasCredential: {
    '@type': 'EducationalOccupationalCredential',
    name: 'Claude Certified Architect',
    recognizedBy: { '@type': 'Organization', name: 'Anthropic' },
  },
};
